import { readEmailQuery } from "./emailPrefill"

const STORAGE_KEY = "coval:signup-email-handoff"
// A delayed navigation must not silently prefill an unrelated later signup.
const MAX_AGE_MS = 5 * 60 * 1000

export function storeSignupEmail(href: string, value: string): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY)
    const email = readEmailQuery(value)
    const target = new URL(href, window.location.origin)
    if (!email || target.origin !== window.location.origin) {
      return
    }
    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        email,
        destination: target.pathname + target.search,
        createdAt: Date.now(),
      }),
    )
  } catch {
    // Storage restrictions should require retyping, never a PII-bearing URL fallback.
  }
}

export function consumeSignupEmail(): string | null {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    window.sessionStorage.removeItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    const value: unknown = JSON.parse(raw)
    if (typeof value !== "object" || value === null) {
      return null
    }
    const { email, destination, createdAt } = value as Record<string, unknown>
    const age = typeof createdAt === "number" ? Date.now() - createdAt : NaN
    if (
      destination !== window.location.pathname + window.location.search ||
      !Number.isFinite(age) ||
      age < 0 ||
      age >= MAX_AGE_MS
    ) {
      return null
    }
    return readEmailQuery(email)
  } catch {
    return null
  }
}
